/**
 * Created by griga on 7/11/16.
 */

import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainLayoutComponent} from './shared/layout/app-layouts/main-layout.component';
import {AuthLayoutComponent} from './shared/layout/app-layouts/auth-layout.component';
import {ManagerGuard} from './manager/manager.guard';

export const routes: Routes = [
  {
    path: 'manager',
    component: MainLayoutComponent,
    data: {pageTitle: 'Home'},
    children: [
      {path: 'createAds', canDeactivate: [ManagerGuard], loadChildren: 'app/manager/manager.module#ManagerModule', data: {pageTitle: 'FB Manager'}},
      {path: 'util',  loadChildren: 'app/utility/utility.module#UtilityModule', data: {pageTitle: 'Utility'}},
    ]
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {path: '', loadChildren: 'app/+auth/auth.module#AuthModule', data: {pageTitle: 'Auth'}},
    ]
  },
  {path: '**', redirectTo: 'auth', pathMatch: 'full'}
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {useHash: true});



// WEBPACK FOOTER //
// ./src/app/app.routing.ts